import { render } from "./UserAccountCard.vue?vue&type=template&id=7bbc8b12&scoped=true"
import script from "./UserAccountCard.vue?vue&type=script&lang=js"
export * from "./UserAccountCard.vue?vue&type=script&lang=js"

import "./UserAccountCard.vue?vue&type=style&index=0&id=7bbc8b12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbc8b12"],['__file',"src/components/UserAccountCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bbc8b12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bbc8b12', __exports__)) {
    api.reload('7bbc8b12', __exports__)
  }
  
  module.hot.accept("./UserAccountCard.vue?vue&type=template&id=7bbc8b12&scoped=true", () => {
    api.rerender('7bbc8b12', render)
  })

}


export default __exports__